/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseGradeRespVo } from './DeliverFeeWarehouseGradeRespVo';
import {
    DeliverFeeWarehouseGradeRespVoFromJSON,
    DeliverFeeWarehouseGradeRespVoFromJSONTyped,
    DeliverFeeWarehouseGradeRespVoToJSON,
    DeliverFeeWarehouseGradeRespVoToJSONTyped,
} from './DeliverFeeWarehouseGradeRespVo';

/**
 * 
 * @export
 * @interface DeliverFeeWarehouseTabRespVo
 */
export interface DeliverFeeWarehouseTabRespVo {
    /**
     * 仓库编号
     * @type {number}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    warehouseId?: number;
    /**
     * 仓库名称-中文
     * @type {string}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    warehouseNameCn?: string;
    /**
     * 仓库名称-韩文
     * @type {string}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    warehouseNameKr?: string;
    /**
     * 运输方式编号
     * @type {number}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    transportMethodId?: number;
    /**
     * 运输方式名称-中文
     * @type {string}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    transportMethodNameCn?: string;
    /**
     * 运输方式名称-韩文
     * @type {string}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    transportMethodNameKr?: string;
    /**
     * 运费类型：1国际运费，2韩国国内运费
     * @type {number}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    feeType?: number;
    /**
     * 运费分组编码（国际：1电商快递2海运物流3橙火服务4韩国3PL；韩国国内：1橙火服务2韩国3PL出库）
     * @type {number}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    orderTypeGroup?: number;
    /**
     * 运费分组名称-中文
     * @type {string}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    orderTypeGroupNameCn?: string;
    /**
     * 运费分组名称-韩文
     * @type {string}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    orderTypeGroupNameKr?: string;
    /**
     * 计费标准 1 重量 2 CBM 3 区间值（国际运费有效，韩国国内为空）
     * @type {number}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    chargeStandard?: number;
    /**
     * 会员等级运费信息
     * @type {Array<DeliverFeeWarehouseGradeRespVo>}
     * @memberof DeliverFeeWarehouseTabRespVo
     */
    grades?: Array<DeliverFeeWarehouseGradeRespVo>;
}

/**
 * Check if a given object implements the DeliverFeeWarehouseTabRespVo interface.
 */
export function instanceOfDeliverFeeWarehouseTabRespVo(value: object): value is DeliverFeeWarehouseTabRespVo {
    return true;
}

export function DeliverFeeWarehouseTabRespVoFromJSON(json: any): DeliverFeeWarehouseTabRespVo {
    return DeliverFeeWarehouseTabRespVoFromJSONTyped(json, false);
}

export function DeliverFeeWarehouseTabRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverFeeWarehouseTabRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseNameCn': json['warehouseNameCn'] == null ? undefined : json['warehouseNameCn'],
        'warehouseNameKr': json['warehouseNameKr'] == null ? undefined : json['warehouseNameKr'],
        'transportMethodId': json['transportMethodId'] == null ? undefined : json['transportMethodId'],
        'transportMethodNameCn': json['transportMethodNameCn'] == null ? undefined : json['transportMethodNameCn'],
        'transportMethodNameKr': json['transportMethodNameKr'] == null ? undefined : json['transportMethodNameKr'],
        'feeType': json['feeType'] == null ? undefined : json['feeType'],
        'orderTypeGroup': json['orderTypeGroup'] == null ? undefined : json['orderTypeGroup'],
        'orderTypeGroupNameCn': json['orderTypeGroupNameCn'] == null ? undefined : json['orderTypeGroupNameCn'],
        'orderTypeGroupNameKr': json['orderTypeGroupNameKr'] == null ? undefined : json['orderTypeGroupNameKr'],
        'chargeStandard': json['chargeStandard'] == null ? undefined : json['chargeStandard'],
        'grades': json['grades'] == null ? undefined : ((json['grades'] as Array<any>).map(DeliverFeeWarehouseGradeRespVoFromJSON)),
    };
}

export function DeliverFeeWarehouseTabRespVoToJSON(json: any): DeliverFeeWarehouseTabRespVo {
    return DeliverFeeWarehouseTabRespVoToJSONTyped(json, false);
}

export function DeliverFeeWarehouseTabRespVoToJSONTyped(value?: DeliverFeeWarehouseTabRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseId': value['warehouseId'],
        'warehouseNameCn': value['warehouseNameCn'],
        'warehouseNameKr': value['warehouseNameKr'],
        'transportMethodId': value['transportMethodId'],
        'transportMethodNameCn': value['transportMethodNameCn'],
        'transportMethodNameKr': value['transportMethodNameKr'],
        'feeType': value['feeType'],
        'orderTypeGroup': value['orderTypeGroup'],
        'orderTypeGroupNameCn': value['orderTypeGroupNameCn'],
        'orderTypeGroupNameKr': value['orderTypeGroupNameKr'],
        'chargeStandard': value['chargeStandard'],
        'grades': value['grades'] == null ? undefined : ((value['grades'] as Array<any>).map(DeliverFeeWarehouseGradeRespVoToJSON)),
    };
}

